import type { ConfigSection, ConfigSectionGroup } from '../interfaces';

/**
 * Order follows the delivery phases of the Configuration Platform, so the top of the
 * menu is what becomes real first. Groups are separated by a divider in the side bar.
 */
export const CONFIG_NAVIGATION: ConfigSectionGroup[] = [
  {
    key: 'access',
    sections: [
      { key: 'users', path: 'users', labelKey: 'config.sections.users', phase: '1.5', status: 'planned' },
      { key: 'roles', path: 'roles', labelKey: 'config.sections.roles', phase: '1', status: 'planned' },
      { key: 'permissions', path: 'permissions', labelKey: 'config.sections.permissions', phase: '1', status: 'planned' },
    ],
  },
  {
    key: 'areas',
    sections: [
      { key: 'featureFlags', path: 'feature-flags', labelKey: 'config.sections.featureFlags', phase: '3', status: 'planned' },
      { key: 'parameters', path: 'parameters', labelKey: 'config.sections.parameters', phase: '4', status: 'planned' },
      { key: 'valueLists', path: 'value-lists', labelKey: 'config.sections.valueLists', phase: '5', status: 'planned' },
      { key: 'translations', path: 'translations', labelKey: 'config.sections.translations', phase: '6', status: 'planned' },
      { key: 'customFields', path: 'custom-fields', labelKey: 'config.sections.customFields', phase: '7', status: 'planned' },
    ],
  },
  {
    key: 'history',
    sections: [{ key: 'auditLog', path: 'audit-log', labelKey: 'config.sections.auditLog', phase: '2', status: 'planned' }],
  },
];

export const CONFIG_SECTIONS: ConfigSection[] = CONFIG_NAVIGATION.flatMap(group => group.sections);

export const DEFAULT_SECTION_PATH = CONFIG_SECTIONS[0].path;

export type CanViewSection = (sectionKey: string) => boolean;

const ALLOW_ALL: CanViewSection = () => true;

/** The groups the account may open, with the sections it may not left out and empty groups dropped. */
export const visibleNavigation = (canViewSection: CanViewSection = ALLOW_ALL): ConfigSectionGroup[] =>
  CONFIG_NAVIGATION.map(group => ({ ...group, sections: group.sections.filter(section => canViewSection(section.key)) })).filter(
    group => group.sections.length > 0,
  );

export const visibleSections = (canViewSection: CanViewSection = ALLOW_ALL): ConfigSection[] =>
  CONFIG_SECTIONS.filter(section => canViewSection(section.key));

/** Where the module lands when no section is named. Undefined when the account may open none. */
export const defaultSectionPath = (canViewSection: CanViewSection = ALLOW_ALL): string | undefined =>
  visibleSections(canViewSection)[0]?.path;
